module.exports = __webpack_public_path__ + "img/15_6.36d66ad7.png";